<template>
    <SimpleForm
      title='Acesso a Campos Extra de Tabelas'
      titleColor='pink'
      :refreshRecord='refreshRecord'
      :refreshLoading='refreshLoading'
      :saveRecord='saveRecord'
      :buttonDelete='deleteRecord'
      :disabledButtonDelete='disabledButtonDelete'
      :disabledButtonRefresh='disabledButtonRefresh'
      :showLog="!!form.recnum"
      :logUrl="`api/CRM/configuracao/campos-extras/${form.recnum}/log?programa=PCP065A1&tabela=CAMPOEXT&chave1=${this.form.seq}&empresa=${this.form.empresa}`"
      :showBtnList="showBtnList"
      :showBtn="showBtn"
      :showBtnNovo="showBtnNovo"
      :showBtnPlus="showBtnPlus"
      :novoItem="novoItem"
      value='Cadastre  um novo campo extra'
      :listItems="listItems"
    >
    <ValidationObserver ref="formValidationObserver" slim>
      <ContainerBody>
        <div class="fields" v-if="inputs">
          <Input
            v-model="form.seq"
            type="number"
            size="one"
            label="Sequência"
            name="seq"
            @input="setDataItem(form.seq)"
            :errors="errors"
          />
          <Input
            v-model="form.nome"
            type="text"
            size="four"
            label="Nome"
            name="Nome"
            maxlength="40"
          />
          <Input
            v-model="form.descricao"
            type="text"
            size="six"
            label="Descrição"
            name="descricao"
            :errors="errors"
            labelIcon="asterisk icon red"
            maxlength="30"
          />
          <Autocomplete
            label="Tipo"
            v-model="form.tipo"
            :items="dataTipos"
          />
          <Input
            v-model="form.tamanho"
            type="number"
            size="one"
            label="Tamanho"
            name="tamanho"
          />
        </div>
        <div v-if="table">
          <div style="display: flex;">
              <PrintExportTable
                title="Campos Extras"
                :dataItems="dataPrint"
                :headerTable="itemsHead"
                :filename="'Campos Extras'"
                style="margin-left: 1px;"
              />
              <div id="btns" v-if="block" style="margin-left: 12px;">
                <Button
                  class="ui button icon green small compact"
                  @click="gravar"
                  :disabled=false
                  title="Gravar"
                  classIcon="check icon"
                />
                <Button
                  class="ui button icon orange small compact"
                  @click="dragOff"
                  :disabled=false
                  title="Restaurar Padrão"
                  classIcon="home icon"
                />
              </div>
            </div>
          <v-data-table
            :headers="activeHeaders"
            :items="dataItems"
            :loading="true"
            dense class="ui table very compact celled selectable dataTable"
            style="width: 100%;
            white-space: nowrap;"
            :hide-default-footer="true"
          >
            <template v-slot:[`header.text`]="{ header }">
              {{ header.text }}
              <input
                type="checkbox"
                @change="getCheckds($event)"
                id="checkbox"
                style="margin-top: 4px;"
              />
            </template>
            <template #body="props">
              <draggable
                :list="props.items"
                tag="tbody"
                :disabled="false"
                handle=".handle"
                @start="dragOn"
                @end="onDropCallback"
              >
              <data-table-row-handler
                v-for="(item, index) in props.items"
                :key="index"
                :item="item"
                :headers="activeHeaders"
              >
              <template #item.handle="{}">
                <i class="icon arrows alternate handle" style="cursor: pointer;"></i>
              </template>
              <template #item.text="{ item }">
                <div class="one wide ui center aligned">
                  <input
                    type="checkbox"
                    id="checkbox"
                    v-model="item.checkbox"
                    :value="item.checkbox"
                    @change="getInputsCheckBox()"
                    style="margin-right: 1px; margin-top: 4px;"
                  />
                </div>
              </template>
              <template #item.buttons="{ item }">
                <div class="one wide ui center aligned">
                  <button
                    type="button"
                    class="ui button icon blue mini compact circular"
                    @click="editarCampoExtra(item.recnum)"
                  >
                  <i class="icon pencil" />
                  </button>
                </div>
              </template>
            </data-table-row-handler>
            </draggable>
          </template>
          </v-data-table>
        </div>
      </ContainerBody>
    </ValidationObserver>
    </SimpleForm>
</template>
<script>
import SimpleForm from '@/components/layouts/SimpleForm.vue';
import ContainerBody from '@/components/ContainerBody.vue';
import Input from '@/components/Input.vue';
import Autocomplete from '@/components/Autocomplete.vue';
import api from '@/services/api';
import '@/config/validation.config';
import PrintExportTable from '@/components/PrintExportTable.vue';
import { ValidationObserver } from 'vee-validate';
import DataTableRowHandler from '@/components/DataTableRowHandler.vue';
import draggable from 'vuedraggable';
import Button from '@/components/Button.vue';

export default {
  name: 'CamposExtrasDeTabelas',
  components: {
    SimpleForm,
    ContainerBody,
    Input,
    Autocomplete,
    PrintExportTable,
    ValidationObserver,
    draggable,
    DataTableRowHandler,
    Button,
  },
  data() {
    return {
      form: {
        recnum: '',
        seq: '',
        nome: '',
        descricao: '',
        tipo: {},
        tamanho: '',
        ordem: '',
        empresa: '',
      },
      disabledButtonDelete: true,
      disabledButtonRefresh: true,
      refreshLoading: false,
      showBtnList: false,
      showBtn: false,
      showBtnNovo: false,
      showBtnPlus: true,
      inputs: false,
      table: true,
      dataTipos: [
        { id: 'T', descricao: 'Texto' },
        { id: 'N', descricao: 'Numérico' },
        { id: 'D', descricao: 'Data' },
        { id: 'C', descricao: 'Caixa de Texto' },
      ],
      headers: [
        {
          text: '',
          value: 'handle',
          align: 'center',
          class: 'one wide ui center aligned',
          sortable: false,
        },
        {
          text: '',
          value: 'text',
          align: 'center',
          class: 'one wide ui center aligned header',
          sortable: false,
        },
        {
          text: 'Ordem',
          value: 'ordem',
          align: 'left',
          class: 'two wide ui left aligned header',
          sortable: false,
        },
        {
          text: 'Seq',
          value: 'seq',
          align: 'left',
          class: 'two wide ui left aligned header',
          sortable: false,
        },
        {
          text: 'Nome',
          value: 'nome',
          align: 'left',
          class: 'two wide ui left aligned header',
          sortable: false,
        },
        {
          text: 'Tipo',
          value: 'tipo',
          align: 'left',
          class: 'one wide ui left aligned header',
          sortable: false,
        },
        {
          text: 'Tamanho',
          value: 'tamanho',
          align: 'left',
          class: 'one wide ui center left header',
          sortable: false,
        },
        {
          text: 'Descrição',
          value: 'descricao',
          align: 'left',
          class: 'three wide ui left aligned header',
          sortable: false,
        },
        {
          text: 'Ações',
          value: 'buttons',
          align: 'center',
          class: 'one wide ui center aligned',
          sortable: false,
        },
      ],
      dataPrint: [],
      itemsHead: [
        { text: 'Seq', value: 'seq' },
        { text: 'Nome', value: 'nome' },
        { text: 'Tipo', value: 'tipo' },
        { text: 'Tamanho', value: 'tamanho' },
        { text: 'Descrição', value: 'descricao' },
      ],
      dataItems: [],
      showLog: '',
      backupArray: [],
      block: false,
      errors: [],
    };
  },
  methods: {
    refreshRecord() {
      this.refreshLoading = true;
      this.$store.commit('global/loading');
      setTimeout(() => {
        this.setDataForm(this.form.recnum);
        this.refreshLoading = false;
        this.disabledButtonRefresh = false;
      }, 1000);
    },
    async saveRecord() {
      this.$store.commit('global/closeAlert');
      this.errors = [];
      try {
        this.form = {
          recnum: this.form.recnum,
          arquivo: 'CONTATO',
          seq: this.form.seq,
          nome: this.form.nome,
          descricao: this.form.descricao,
          tipo: this.form.tipo.id,
          tamanho: this.form.tamanho,
          ordem: this.form.ordem,
        };
        this.$store.commit('global/loading');
        if (this.form.recnum == '' || this.form.recnum == undefined) {
          await api.post('/api/CRM/configuracao/campos-extras', this.form)
            .then((result) => {
              this.$alertify.success(result.data.message);
              this.dataItems.push(result.data.data);
              this.dataPrint.push(result.data.data);
              this.$store.commit('global/loaded');
              this.clearForm();
            });
        } else {
          await api.put(`/api/CRM/configuracao/campos-extras/${this.form.recnum}`, this.form)
            .then((result) => {
              this.$alertify.success(result.data.message);
              this.dataItems = this.dataItems.map(item => {
                if (item.recnum === this.form.recnum) {
                  return { ...item, ...result.data.data };
                }
                return item;
              });
              this.dataPrint = this.dataPrint.map(item => {
                if (item.recnum === this.form.recnum) {
                  return { ...item, ...result.data.data };
                }
                return item;
              });
              this.$store.commit('global/loaded');
            });
        }
      } catch (error) {
        if (error.response.data.errors) {
          this.errors = error.response.data.errors;
        }
        this.$store.commit('global/openAlert');
      } finally {
        this.loadingPrint();
        this.$store.commit('global/loaded');
      }
    },
    async deleteRecord() {
      this.$store.commit('global/loading');
      const itemsDelete = this.dataItems.filter((item) => (item.checkbox == true))
        .map(item => item.recnum);
      let url = '/api/CRM/configuracao/campos-extras';
      if (this.form.recnum) {
        url += `/${this.form.recnum}`;
      }
      try {
        await api({
          method: 'delete',
          url,
          data: this.form.recnum ? null : { itens: itemsDelete },
        })
          .then((result) => {
            if (result.data) {
              if (itemsDelete.length > 0) {
                itemsDelete.forEach(item => {
                  const foundIndex = this.dataItems.findIndex(linha => item == linha.recnum);
                  const foundIndexPrint = this.dataPrint.findIndex(linha => item == linha.recnum);
                  if (foundIndex >= 0) {
                    this.dataItems.splice(foundIndex, 1);
                  }
                  if (foundIndexPrint >= 0) {
                    this.dataPrint.splice(foundIndex, 1);
                  }
                });
              } else {
                const itemSplice = this.dataItems.findIndex(linha => linha.recnum == this.form.recnum);
                this.dataItems.splice(itemSplice, 1);
              }
              this.clearForm();
              this.$alertify.success(result.data.message);
            }
          });
      } catch (error) {
        if (error.response) {
          this.$alertify.error(error.response.data.message, 10);
        }
      }
      this.loadingPrint();
      this.$store.commit('global/loaded');
      this.disabledButtonDelete = true;
    },
    novoItem() {
      this.errors = [];
      this.inputs = true;
      this.table = false;
      this.showBtnList = true;
      this.showBtn = true;
      this.clearForm();
    },
    listItems() {
      this.errors = [];
      this.table = true;
      this.inputs = false;
      this.showBtn = false;
      this.showBtnList = false;
      this.disabledButtonDelete = true;
      this.clearForm();
    },
    async loadingRecords() {
      this.$store.commit('global/loading');
      await api.get('/api/CRM/configuracao/campos-extras')
        .then((result) => {
          if (result.data.data.length > 0) {
            this.table = true;
          }
          const dados = result.data.data.reduce((itens, item) => {
            itens.push(
              {
                recnum: item.recnum,
                descricao: item.descricao,
                empresa: item.empresa,
                nome: item.nome,
                seq: item.seq,
                tamanho: item.tamanho,
                tipo: item.tipo,
                valores: item.valores,
                ordem: item.ordem,
              },
            );
            return itens;
          }, []);
          if (dados) {
            this.dataItems = dados;
            this.backupArray = [...this.dataItems];
            this.$store.commit('global/loaded');
          }
        });
      this.$store.commit('global/loaded');
    },
    async setDataForm(recnum) {
      this.$store.commit('global/loading');
      try {
        api.get(`/api/CRM/configuracao/campos-extras/${recnum}`)
          .then((result) => {
            if (result.data) {
              this.form.recnum = result.data.data.recnum;
              this.form.seq = result.data.data.seq;
              this.form.nome = result.data.data.nome;
              this.form.descricao = result.data.data.descricao;
              this.form.tipo = { id: result.data.data.tipo };
              this.form.tamanho = result.data.data.tamanho;
              this.form.valores = result.data.data.valores;
              this.form.empresa = result.data.data.empresa;
            }
          });
      } catch (error) {
        this.$store.commit('global/closeAlert');
        this.disabledButtonRefresh = true;
        this.alertTitle = 'Atenção';
        this.alertMessage = 'Registro não encontrado';
        this.$store.commit('global/openAlert');
      } finally {
        this.$store.commit('global/loaded');
      }
    },
    async clearForm() {
      const proximaSequencia = await api.get('/api/CRM/configuracao/campos-extras/sequencia/item/proximo');
      this.form = {
        recnum: '',
        seq: proximaSequencia.data.data.ultimaSequencia,
        nome: '',
        descricao: '',
        tipo: { id: 'T' },
        tamanho: 0,
        ordem: proximaSequencia.data.data.ultimaOrdem,
      };
      this.errors = [];
    },
    async setDataItem(seq) {
      const result = await api.get(`/api/CRM/configuracao/campos-extras/sequencia/${seq}`);
      if (result.data.data) {
        this.form = {
          id: result.data.data.recnum,
          seq: result.data.data.seq,
          nome: result.data.data.nome,
          descricao: result.data.data.descricao,
          tipo: { id: result.data.data.tipo },
          tamanho: result.data.data.tamanho,
          recnum: result.data.data.recnum,
          empresa: result.data.data.empresa,
        };
        this.disabledButtonDelete = false;
      } else {
        this.disabledButtonRefresh = true;
        this.table = false;
      }
    },
    editarCampoExtra(recnum) {
      this.disabledButtonDelete = false;
      this.disabledButtonRefresh = false;
      this.showBtn = true;
      this.mostrar = true;
      this.showItems = true;
      this.inputs = true;
      this.table = false;
      this.showBtnList = true;
      const editar = this.dataItems.find(item => item.recnum == recnum);
      this.setDataForm(editar.recnum);
    },
    getInputsCheckBox() {
      const itemsChecked = this.dataItems.filter((item) => (item.checkbox == true));
      const verificaItemsChecked = itemsChecked.length == 0 ? this.disabledButtonDelete = true : this.disabledButtonDelete = false;
      return verificaItemsChecked;
    },
    getCheckds() {
      const checkbox = document.getElementById('checkbox');
      if (checkbox.checked == true) {
        this.disabledButtonDelete = false;
        this.dataItems.forEach(item => {
          item.checkbox = true;
        });
      } else {
        this.disabledButtonDelete = true;
        this.dataItems.forEach(item => {
          item.checkbox = false;
        });
      }
    },
    async loadingPrint() {
      this.$store.commit('global/loading');
      await api.get('/api/CRM/configuracao/campos-extras')
        .then((result) => {
          const dados = result.data.data.reduce((itens, item) => {
            if (item.tipo == 'T') {
              item.tipo = 'TEXTO';
            } else if (item.tipo == 'N') {
              item.tipo = 'NUMÉRICO';
            } else if (item.tipo == 'D') {
              item.tipo = 'DATA';
            } else {
              item.tipo = 'CAIXA DE TEXTO';
            }
            itens.push(
              {
                recnum: item.recnum,
                descricao: item.descricao,
                empresa: item.empresa,
                nome: item.nome,
                seq: item.seq,
                tamanho: item.tamanho,
                tipo: item.tipo,
                valores: item.valores,
              },
            );
            return itens;
          }, []);
          if (dados) {
            this.dataPrint = dados;
            this.$store.commit('global/loaded');
          }
        });
    },
    dragOn() {
      this.block = true;
    },
    dragOff() {
      this.block = false;
      this.dataItems = this.backupArray;
      this.loadingRecords();
    },
    onDropCallback(evt) {
      const itemArray = this.dataItems.splice(evt.oldDraggableIndex, 1)[0];
      this.dataItems.splice(evt.newDraggableIndex, 0, itemArray);
      let count = 0;
      this.dataItems.forEach((reg) => {
        count += 1;
        reg.ordem = count;
      });
    },
    async gravar() {
      this.$store.commit('global/loading');
      const dados = this.dataItems.reduce((itens, item) => {
        itens.push(
          {
            id: item.recnum,
            ordem: item.ordem,
          },
        );
        return itens;
      }, []);
      const url = '/api/CRM/configuracao/campos-extras';
      const itensRetornados = dados;
      try {
        await api({
          method: 'PUT',
          url,
          data: { itens: itensRetornados },
        })
          .then((result) => {
            if (result.data) {
              this.clearForm();
              this.$alertify.success(result.data.message);
              this.block = false;
            }
          });
      } catch (error) {
        if (error.response) {
          this.$alertify.error(error.response.data.message, 10);
        }
      }
      this.$store.commit('global/loaded');
    },
  },
  async mounted() {
    await this.loadingRecords();
    await this.loadingPrint();
  },
  watch: {
    options: {
      async handler() {
        await this.loadingRecords();
        await this.loadingPrint();
      },
    },
  },
  computed: {
    activeHeaders() {
      return this.headers.filter((h) => {
        if (h.value === 'lock') {
          return false;
        }
        return true;
      });
    },
  },
};
</script>
<style>
input[type="number"]::-webkit-outer-spin-button,
input[type="number"]::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}
input[type="number"] {
    -moz-appearance: textfield;
}

th > span {
  font-size: 14px;
  color: #000;
}

tbody tr td {
  padding-left: 10px !important;
}

tbody td div{
  font-weight: normal;
  font-size: .875rem;
}

</style>
